import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/trades")({
  component: lazyRouteComponent(() => import("@/pages/admin/Trades")),
});
